<template>
  <div class="layout-container" :class="{
    isMobile: isMobile()
  }">
    <!-- 公共头部 -->
    <div class="header-container sys-max-width">
      <div class="header-left">
      </div>

      <div v-if="isShowLayoutInfo()" class="header-right">
        <!-- 菜单 -->
        <div class="menu-box" v-if="!isMobile()">
          <div class="menu-item"
            :class="{
              active: currentMenu === item.router
            }"
            :key="index"
            v-for="(item, index) in moduleList"
            @click="goMenu(item)"
          >{{ item.name }}</div>
        </div>

        <div 
          v-else 
          class="mobile-menu-icon"
          :class="isShowMobileMenu ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
          @click="isShowMobileMenu = !isShowMobileMenu">
        </div>

        <el-dropdown @command="dropdownClick" trigger="click" v-if="isLogin()">
          <span class="el-dropdown-link user-info flex items-center">
            <div class="avatar overflow-hidden">
              <img class="img-common" :src="avaUrl" />
            </div>
            <div class="mobile">{{ getAccount() }}</div>
          </span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="my-info">我的信息</el-dropdown-item>
            <el-dropdown-item command="my-look">浏览记录</el-dropdown-item>
            <el-dropdown-item command="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div v-else class="no-login">
          <el-button size="small" @click="goLoginPage">登录</el-button>
          <el-button size="small" @click="$router.push({name: 'registry'})">注册</el-button>
        </div>
      </div>
    </div>

    <!-- mobile menu -->
    <div class="mobile-menu" v-if="isMobile() && isShowMobileMenu">
      <el-menu
        class="el-menu-box"
        :default-active="currentMenu"
        @select="mobileMenuSelect"
      >
        <el-menu-item v-for="item in moduleList" :key="item.router" :index="item.router">
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>

    <transition name="fade">
      <router-view v-if="isShowRouterView"></router-view>
    </transition>

    <!-- 公共底部 -->
    <div v-if="isShowLayoutInfo() && $route.name !== 'axt'" class="footer-container">
      <div class="sys-max-width">
        <div class="footer-top flex items-start justify-between">
          <div class="left-block flex">

            <div class="us">
              <div class="us-text">联系我们：</div>
              <div class="mobile">010-5852 8506</div>
              <div class="email">邮箱地址：</div>
              <div class="email-text">foundation@catzgroup.com</div>
              <div class="local-text">地址：</div>
              <div class="local">北京市西城区闹市口大街1号长安兴融中心4号楼11层</div>
            </div>

            <div class="item-block flex">
              <div class="item">
                <div class="title">关于我们</div>

                <div @click="$router.push({name: 'about-detail', params: {id: item.id}})" v-for="item in aboutList" :key="item.id" class="f-title ellipsis">{{ item.name }}</div>
              </div>

              <div class="item">
                <div class="title">基金会项目</div>

                <div @click="goDetail(item)" :key="index" v-for="(item, index) in indexNewsList" class="f-title ellipsis">{{ item.title }}</div>
              </div>

              <div class="item">
                <div class="title">信息公开</div>

                <div v-for="item in infoList" :key="item.id" @click="$router.push({name: 'info-detail', params: {id: item.id}})" class="f-title ellipsis">{{ item.name }}</div>
              </div>
            </div>


          </div>

          <div class="right-block">
            <div class="top-img">
            </div>

            <div class="desc">关注微信公众号</div>
          </div>
        </div>

        <div class="footer-bottom">
          北京长安投资公益基金会版权所有 Copyright 2002 BJCAIF All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import { MODULE_CONFIG, moduleConfig } from '@/config/index'
import { fetchModuleList } from '@/api/module'
import { fetchCustomList } from '@/api/common'
import { logout } from '@/api/login'
import { isLogin, getAccount, removeUserInfo, getAva } from '@/utils/auth'
import eventBus from '@/utils/bus'
import { isMobile } from '@/utils/index'

export default {
  data() {
    return {
      currentMenu: '',

      isShowMobileMenu: false,

      avaUrl: getAva(),

      isShowRouterView: true
    }
  },

  computed: {
    ...mapGetters({
      moduleList: 'moduleList',
      indexNewsList: 'indexNewsList'
    }),

    aboutList() {
      return this.$store.getters.getSecondModuleById(MODULE_CONFIG.US)
    },

    infoList() {
      return this.$store.getters.getSecondModuleById(MODULE_CONFIG.INFO)
    }
  },

  watch:{
    $route(newVal) {
      this.setMenuIndex(newVal)
    }
  },

  methods: {
    isLogin,
    getAccount,
    isMobile,

    reload() {
      this.isShowRouterView = false

      this.$nextTick(() => {
        this.isShowRouterView = true
      })
    },

    isShowLayoutInfo() {
      return this.$route.name !== 'mInput'
    },

    initEventBus() {
      eventBus.$on('after-login', (data) => {
        const { avatar } = data

        this.avaUrl = avatar
      })
    },

    mobileMenuSelect(e) {
      if (e === this.currentMenu) {
        window.location.reload()
        return
      }

      this.currentMenu = e

      this.isShowMobileMenu = false

      this.$router.push({
        name: e
      })
    },

    async dropdownClick(e) {
      if (e === 'logout') {
        try {
          await logout()
          removeUserInfo()
          this.$message.success('成功退出')
          window.location.href = window.location.protocol + '//' + window.location.host
        } catch (error) {
          console.log(error)
        }
      } else {
        this.$router.push({
          name: e
        })
        // console.log(e)
      }

    },

    goDetail(item) {
      this.$router.push({
        name: 'contentDetail',
        query: {
          moduleId: item.pid,
          moduleSecId: item.cate_id,
          contentId: item.object_code
        }
      })
    },

    setRouter(item) {
      for (let i = 0; i < moduleConfig.length; i++) {
        const mItem = moduleConfig[i]

        if (Number(mItem.id) === Number(item.id)) {

          item.router = mItem.router
          break
        }
      }
    },

    async getModuleList() {
      try {
        const data = await fetchModuleList()

        data.forEach(item => {
          this.setRouter(item)

          if (Array.isArray(item.children) && item.children.length > 0) {
            for (let i = 0; i < item.children.length; i++) {

              this.setRouter(item.children[i])
            }
          }
        })

        this.$store.dispatch('app/setModuleList', data)
      } catch (error) {
        console.log(error)
      }
    },

    goLoginPage() { // 跳转到登录页
      this.$router.push({
        name: 'login',
        query: {
          redirect: this.$route.fullPath
        }
      })
    },

    setMenuIndex(route) {
      const { name, query } = route
      if (name === 'about-detail') {
        this.currentMenu = 'about'
      } else if (name === 'news-list') {
        this.currentMenu = 'news'
      } else if (name === 'info-detail') {
        this.currentMenu = 'info'
      } else {
        if (name === 'contentDetail') { // 内容详情页
          if (query.moduleId === MODULE_CONFIG.WELFARE) {
            this.currentMenu = 'publicWelfare'
          } else if (query.moduleId === MODULE_CONFIG.US) {
            this.currentMenu = 'about'
          } else if (query.moduleId === MODULE_CONFIG.NEWS) {
            this.currentMenu = 'news'
          }
        } else if (name === 'videoDetail' || name === 'video-tip' || name === 'video-sec') { // 视频详情页
          this.currentMenu = 'video'
        } else {
          this.currentMenu = name
        }
      }
    },

    goMenu(item) {
      console.log(item.router)
      console.log(this.currentMenu)
      console.log(this.$route.name)

      if (item.router === this.currentMenu) {
        const routeName = this.$route.name
        if (routeName === 'contentDetail' || routeName === 'videoDetail') {
          this.$router.push({
            name: item.router
          })
        } else {
          this.$router.push({
            name: item.router
          })

          this.reload()
        }

        return
      }

      this.currentMenu = item.router

      this.$router.push({
        name: item.router
      })
    },

    async getNewsList() {
      try {
        const { contents, data } = await fetchCustomList({
          action: 'feeds',
          type: 2
        })

        let targetData = []
        if (contents) {
          const contentsData = JSON.parse(contents)

          targetData = contentsData.map((item) => {
            const target = data.find(i => i.id === item.id)

            return target
          })
        }

        this.$store.dispatch('app/setIndexNewsList', targetData)
      } catch (error) {

      }
    },
  },
  created() {
    this.getModuleList()
    this.setMenuIndex(this.$route)

    this.initEventBus()

    this.getNewsList()
  }
}
</script>

<style lang="scss">
.layout-container {
  &.isMobile {
    position: relative;

    .header-container {
      padding: 0 20px;
      .header-left {
        width: 180px;
        height: 27px;
      }

      .header-right {
        .no-login {
          margin-left: 10px;
        }
      }
    }

    .mobile-menu {
      background-color: $primary;
      position: absolute;
      top: 72px;
      left: 0;
      right: 0;
      z-index: 999;
      // transition;

    }


    .footer-container {
      .sys-max-width {
        padding: 0 20px;

        .footer-top {
          display: block;
          .left-block {
            // display: block;
            margin-bottom: 20px;
            .item-block {
              display: none;
            }
          }

          .right-block {
            .top-img {
              margin: 0 auto 20px;
            }
          }
          
        }
      }
    }
  }

  .header-container {
    height: 72px;
    display: flex;
    justify-content: space-between;
    align-items: center;


    .header-left {
      width: 318px;
      height: 48px;
      background: url(~@/assets/logo.png) no-repeat;
      background-size: 100% 100%;
    }

    .header-right {
      display: flex;
      align-items: center;

      .mobile-menu-icon {
        font-size: 20px;
        color: #0A1121;
      }

      .menu-box {
        display: flex;
        align-items: center;

        .menu-item {
          // width: 572px;
          // height: 17px;
          font-size: 16px;
          font-weight: bold;
          color: #3C4858;
          margin-right: 15px;
          cursor: pointer;
          transition: .1s;

          &:last-child {
            margin-right: 0;
          }

          &.active, &:hover {
            color: #1296DB;
          }
        }
      }

      .no-login {
        margin-left: 34px;
        display: flex;
        align-items: center;
      }

      .user-info {
        margin-left: 15px;
        cursor: pointer;

        .avatar {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          // background-color: $primary;
          margin-right: 9px;
        }

        .mobile {
          font-size: 14px;
          font-weight: 400;
          color: #0A1121;
        }
      }
    }
  }

  .footer-container {
    background-color: #0D223C;



    .footer-top {
      padding-top: 44px;
      margin-bottom: 36px;

      .left-block {
        .us {
          margin-right: 110px;
          .us-text {
            font-size: 16px;
            color: #FEFBFB;
            margin-bottom: 10px;
          }

          .mobile {
            font-size: 30px;
            color: #FEFBFB;
            margin-bottom: 10px;
          }

          .email {
            font-size: 14px;
            color: #A6A9B0;
            margin-bottom: 3px;
          }

          .email-text {
            font-size: 14px;
            color: #A6A9B0;
            margin-bottom: 10px;
          }

          .local-text {
            font-size: 14px;
            color: #A6A9B0;
            margin-bottom: 3px;
          }

          .local {
            font-size: 14px;
            color: #A6A9B0;
            margin-bottom: 10px;
          }
        }

        .item-block {
          .item {
            margin-right: 61px;
            flex-shrink: 0;
            max-width: 100px;

            &:last-child {
              margin-right: 0;
            }

            .title {
              color: #FEFBFB;
              font-size: 16px;
              margin-bottom: 15px;
            }

            .f-title {
              color: #A6A9B0;
              font-size: 12px;
              margin-bottom: 5px;
              cursor: pointer;
              transition: 0.1s;

              &:hover {
                color: #FEFBFB;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }

      .right-block {
        .top-img {
          width: 133px;
          height: 131px;
          background: url(~@/assets/wx.png) no-repeat;
          background-size: 100% 100%;
          margin-bottom: 23px;
        }

        .desc {
          font-size: 12px;
          text-align: center;
          font-weight: 400;
          color: #A6A9B0;
          line-height: 24px;
        }
      }

    }

    .footer-bottom {
      padding-top: 24px;
      padding-bottom: 32px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(166, 169, 176, 0.5);
      line-height: 36px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
